import ProfileAPI from '../data/profile-api-client.js'

export default class ProfileService {
    static async store (profilePayload) {}

    static async show () {
        try {
            const {
                data,
            } = await ProfileAPI.show()

            return data
        } catch (error) {
            console.error('ProfileService.show - Error:', error)
            throw error
        }
    }

    static async showLimited (profileId) {
        try {
            const {
                data,
            } = await ProfileAPI.showLimited(profileId)

            return data
        } catch (error) {
            console.error('ProfileService.showLimited - Error:', error)
            throw error
        }
    }

    static async update (profilePayload) {
        try {
            await ProfileAPI.update(profilePayload)
            const {
                data: updatedProfile,
            } = await ProfileAPI.show()
            return updatedProfile
        } catch (error) {
            throw error
        }
    }

    static async updateAvatar (avatarPayload) {
        try {
            return await ProfileAPI.updateAvatar(avatarPayload)
        } catch (error) {
            throw error
        }
    }

    /**
    * Fetches a public profile using a referral code.
    *
    * @param {string} referralCode - The referral code to look up.
    * @returns {object|undefined} - The profile data if found, or undefined if not found.
    *
    * Notes:
    * - Gracefully returns undefined if the referral code is invalid (404).
    * - Throws all other unexpected errors (e.g. network issues, 500s).
    */
    static async showByReferralCode (referralCode) {
        try {
            const {
                data,
            } = await ProfileAPI.showByReferralCode(referralCode)
            return data
        } catch (error) {
            if (error?.statusCode === 404) return // Referral code not found — treat as undefined
            throw error // Rethrow other errors
        }
    }

    static async getReferralSummary () {
        try {
            const {
                data,
            } = await ProfileAPI.getReferralSummary()
            return data
        } catch (error) {
            throw error
        }
    }

    static async submitReferralFeedback (request) {
        const {
            data,
        } = await ProfileAPI.submitReferralFeedback(request)
        return data
    }

    /**
     * TENANT-5570 — see ProfileAPI.requestTaxIdAssistance.
     * @returns {Promise<{ requested_at: string }>}
     */
    static async requestTaxIdAssistance () {
        const {
            data,
        } = await ProfileAPI.requestTaxIdAssistance()
        return data
    }

    static async getMyReviews () {
        const {
            data: reviews,
        } = await ProfileAPI.getMyReviews()
        return reviews
    }

    static async getReviews (profile_id) {
        const {
            data: reviews,
        } = await ProfileAPI.getReviews(profile_id)
        return reviews
    }
}
